<div class="bc-modal column-picker-container">
  <div class="modal-content modal-dialog column-picker-content">

    <div class="modal-header">
      <div class="modal-title">{{ 'columnPicker.modalTitle' | translate }}</div>
      <svg-icon icon="x" class="icon-close" (click)="cancelClicked()"></svg-icon>
    </div>

    <div class="modal-body column-picker-body">
      <div class="column-display-settings">
        <mat-form-field class="column-sort-by">
          <mat-select [(value)]="columnSortBy" placeholder="{{ 'columnPicker.sortByPlaceholder' | translate }}">
            <mat-option value="appearance">{{ 'columnPicker.byAppearance' | translate }}</mat-option>
            <mat-option value="name">{{ 'columnPicker.byName' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="column-list-filter-input">
          <svg-icon icon="magnifier" matPrefix></svg-icon>
          <input matInput [(ngModel)]="filterText" placeholder="{{ 'columnPicker.searchPlaceholder' | translate }}" />
        </mat-form-field>
      </div>

      <div class="column-list-header">
        <div class="modal-title column">{{ 'columnPicker.column' | translate }}</div>
        <div class="modal-title condition">{{ 'columnPicker.warningConditions' | translate }}</div>
      </div>
      <div class="column-name-list">
        <div class="column-list-item"
          *ngFor="let column of columnSettings | appColumnSortBy: columnSortBy | appColumnNameFilter: filterText">
          <mat-checkbox [checked]="!isColumnHidden(column)" [disableRipple]="true"
                        (change)="setColumnHidden(column, !$event.checked)">{{ column.displayName | translate }}</mat-checkbox>
          <div *ngIf="canHaveTimeCondition(column)" class="condition">
            <ng-container *ngIf="!conditionForm.controls[column.id]">
              <div *ngIf="!isCachedColumnHidden(column)" class="edit-mode" (mouseenter)="column.hover=true" (mouseleave)="column.hover=false">
                <div class="condition-text" (click)="clickToEdit(column)">{{ (column.hover ? 'columnPicker.setCondition' : 'columnPicker.noCondition') | translate }}</div>
                <a (click)="clickToEdit(column)" class="icon-edit">
                  <i class="glyphicon glyphicon-pencil"></i>
                </a>
              </div>
              <div *ngIf="isCachedColumnHidden(column)" class="non-edit-mode">
                <div class="condition-text">{{ 'columnPicker.noCondition' | translate }}</div>
              </div>
            </ng-container>
            <div *ngIf="conditionForm.controls[column.id]">
              <div class="edit-condition">
                <div class="title">{{ 'columnPicker.eventOlderThan' | translate }}</div>
                <div class="duration-picker">
                  <form [formGroup]="conditionForm.controls[column.id]">
                    <mat-form-field class="minutes">
                      <input matInput maxlength="3" placeholder="{{ 'columnPicker.minutesPlaceholder' | translate }}" formControlName="minutes">
                      <mat-error>
                        <mat-error class="error-message">{{ 'columnPicker.minutesError' | translate }}</mat-error>
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field class="seconds">
                      <input matInput maxlength="2" placeholder="{{ 'columnPicker.secondsPlaceholder' | translate }}" formControlName="seconds">
                      <mat-error>
                        <mat-error class="error-message">{{ 'columnPicker.secondsError' | translate }}</mat-error>
                      </mat-error>
                    </mat-form-field>
                  </form>
                </div>
                <button type="button" (click)="setToNoCondition(column)" class="delete-condition">
                  <svg-icon icon="x"></svg-icon>
                  <ng2-tooltip direction="right" text="{{ 'columnPicker.deleteTooltip' | translate }}"></ng2-tooltip>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer column-picker-footer">
      <div class="btn-group">
        <button class="btn btn-light button-cancel" (click)="cancelClicked()">
          <span>{{ 'columnPicker.cancelButton' | translate }}</span>
        </button>
        <button class="btn btn-dark button-save" (click)="saveClicked()" [disabled]="!isFormValid">
          <svg-icon icon="checkmark" class="icon-checkmark"></svg-icon>
          <span>{{ 'columnPicker.saveButton' | translate }}</span>
        </button>
      </div>
    </div>

  </div>
</div>
